var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderglow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 133,
    viewBox: "0 0 330 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_473_1100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 132.79H330V47.142C330 38.3054 322.837 31.142 314 31.142H121.14C118.217 31.142 115.349 30.341 112.849 28.826L95.5029 18.3159C93.0026 16.801 90.135 16 87.2116 16H16C7.16344 16 0 23.1634 0 32V132.79Z",
    fill: "url(#paint0_linear_473_1100)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_473_1100",
    x: -16,
    y: 0,
    width: 362,
    height: 148.789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_473_1100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_473_1100",
    x1: 192.064,
    y1: 0.240357,
    x2: 121.379,
    y2: 130.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3496FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#427FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderglow);
export default __webpack_public_path__ + "static/media/folderglow.951335fada6a0073d73765835bae93c8.svg";
export { ForwardRef as ReactComponent };